import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

// Lazy-load page placeholders (will be replaced with real pages later)
const Overview = React.lazy(() => import('./pages/Overview'));
const Users = React.lazy(() => import('./pages/Users'));
const Economy = React.lazy(() => import('./pages/Economy'));
const Matches = React.lazy(() => import('./pages/Matches'));
const Moderation = React.lazy(() => import('./pages/Moderation'));
const System = React.lazy(() => import('./pages/System'));
const Rankings = React.lazy(() => import('./pages/Rankings'));
const Store = React.lazy(() => import('./pages/Store'));

export default function AppRoutes() {
  return (
    <React.Suspense fallback={<div className="win-panel" style={{ padding: 16 }}>Loading...</div>}>
      <Routes>
        <Route path="/" element={<Overview />} />
        <Route path="/users" element={<Users />} />
        <Route path="/economy" element={<Economy />} />
        <Route path="/matches" element={<Matches />} />
        <Route path="/moderation" element={<Moderation />} />
        <Route path="/system" element={<System />} />
        <Route path="/rankings" element={<Rankings />} />
        <Route path="/store" element={<Store />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </React.Suspense>
  );
}
